import { absoluteCentre, marginTop, typography } from "../../styles";
import { AppointeddLogo } from "../AppointeddLogo/AppointeddLogo";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${absoluteCentre}
  top: 20%;
  max-width: 17.5rem;
`;
const Logo = styled(AppointeddLogo)`
  height: 7.5rem;
  width: 7.5rem;
`;
const Text = styled.h1`
  ${marginTop.m}

  ${typography.title}
  text-align: center;
  &::first-letter {
    text-transform: capitalize;
  }
`;
export function FullPageError() {
  const {
    t
  } = useTranslation();
  return <Container data-sentry-element="Container" data-sentry-component="FullPageError" data-sentry-source-file="FullPageError.tsx">
      <Logo data-sentry-element="Logo" data-sentry-source-file="FullPageError.tsx" />
      <Text data-sentry-element="Text" data-sentry-source-file="FullPageError.tsx">{t("errors.appLoad")}</Text>
    </Container>;
}
export default FullPageError;